import ChatIcon from "../../assets/img/chat-icon2.png";
import React, {memo} from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        pointerEvents: 'all',
        padding: 10,
        maxWidth: 280,
        display: 'flex',
        alignItems: 'center',
        margin: '0 3.1vw 0 0',
    },
    messageTypoContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    typo: {
        fontSize: props => props.width * 0.5,
        display: 'inline-block',
        verticalAlign: 'middle',
        color: 'white',
        cursor: 'pointer',
        fontWeight: 400,
        margin: '0 6px 0 6px !important',
        textAlign: 'center',
        alignItems: 'center'
    },
    img: {
        maxWidth: '100%',
        width: props => window.innerWidth > 900 ? '25%' : props.width * 0.8,
        display: 'inline-block',
        verticalAlign: 'middle'
    }
})

const MessagesLink = ({width, onClick}) => {

    const classes = useStyles({width});

    return (<div className={classes.root}>
        {/*<a className={classes.messageTypoContainer} onClick={onClick}>*/}
        {/*            <span className={classes.typo}>Message</span>*/}
        {/*    <img alt={'Message '} className={classes.img} src={ChatIcon}/>*/}
        {/*</a>*/}
    </div>)
}

export default memo(MessagesLink)